import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import { filterInitialValue } from "../config";
import SimpleDate from "../../../../modules/SimpleDate";
import Api from "../../../../Services/Api";
import { fetchDataAsync } from "../../../../Services/Utils";
import { HttpStatus } from "../../../common/Constants";
import { mapToObjectDDL, removeNullFields } from "../../../common/mapper";
import moment from "moment";

class MasterPromoFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: filterInitialValue,
      combinationData: [
        { label: "YA", value: true },
        { label: "TIDAK", value: false },
      ],
      statusData: [
        { label: "AKTIF", value: "ACTIVE" },
        { label: "TIDAK AKTIF", value: "INACTIVE" },
      ],
      cabangOptions: [],
      areaOption: [],
    };
  }

  handleSubmit = () => {
    const { onSubmit } = this.props;
    const { filter } = this.state;
    onSubmit(filter);
  };

  handleClear = () => {
    this.setState({
      filter: filterInitialValue,
    });
  };

  handleSetValue = ({ value, name }) => {
    this.setState((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        [name]: value,
      },
    }));
  };

  componentDidMount() {
    const { submitedFilter } = this.props;
    console.log(submitedFilter);

    if (submitedFilter) {
      this.setState({ filter: submitedFilter });
    }
    this.fetchDataCabang();
    this.fetchDataArea();
  }

  fetchDataCabang = async () => {
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
      menuName: "Master Package",
      setError: this.props.setError,
      args: {},
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const filteredData = res?.data?.data?.filter((item) =>
        this.props.menuAccess
          .map((data) => data.idRefObj)
          .includes(item?.kodeCabang)
      );
      this.setState({
        cabangOptions:
          filteredData?.map((item) =>
            mapToObjectDDL(item?.namaDealer, item?.kodeCabang)
          ) || [],
      });
    }
  };

  fetchDataArea = async () => {
    const dataCabang = this.props.dataCabang;
    const listIdWilayah = [
      ...new Set(dataCabang.map((item) => item.idWilayah).filter(Boolean)),
    ];

    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllByListKey,
      menuName: `Master Promo H2`,
      setError: this.props.setError,
      args: listIdWilayah,
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prevValue) => ({
        ...prevValue,
        areaOption: res.data.data.map((item) =>
          mapToObjectDDL(item.value, item.key)
        ),
      }));
    }
  };

  render() {
    const { visible, onClickClose } = this.props;
    const { filter, combinationData, statusData, cabangOptions, areaOption } =
      this.state;
    return (
      <React.Fragment>
        <SimpleModal
          title="Filter"
          visible={visible}
          styles={{ width: "50%" }}
          onClickClose={onClickClose}
          content={
            <ModalContainer>
              <FlexView column style={{ gap: "15px" }}>
                <SimpleInput
                  name="promoId"
                  label="Promo ID"
                  value={filter.promoId}
                  onChange={({ target }) => this.handleSetValue(target)}
                />
                <SimpleInput
                  name="namaPromo"
                  label="Nama Promo"
                  value={filter.namaPromo}
                  onChange={({ target }) => this.handleSetValue(target)}
                />
                <FlexView column>
                  <div className="txt-site txt-11 txt-main txt-bold margin-5px">
                    <h4>Tanggal Mulai dan Selesai Promo</h4>
                  </div>
                  <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                    <SimpleDate
                      id="select_date_startDate"
                      name="startDate"
                      styles={{ flex: 1 }}
                      nextdate
                      date={filter.startDate}
                      maxDate={filter.endDate}
                      onChange={(value) =>
                        this.handleSetValue({
                          value: moment(value).format("DD-MM-YYYY"),
                          name: "startDate",
                        })
                      }
                    />
                    <span className="margin-bottom-20px">To</span>
                    <SimpleDate
                      id="select_date_endDate"
                      name="endDate"
                      // nextdate
                      date={filter.endDate}
                      onChange={(value) =>
                        this.handleSetValue({
                          value: moment(value).format("DD-MM-YYYY"),
                          name: "endDate",
                        })
                      }
                    />
                  </FlexView>
                </FlexView>
                <SimpleDDL
                  label="Promo boelh digabung dengan voucher?"
                  id="select_combination"
                  name="combination"
                  box="search"
                  placeholder="YA / TIDAK"
                  options={combinationData}
                  isClearable
                  value={filter.combination}
                  onChange={(value) =>
                    this.handleSetValue({ value, name: "combination" })
                  }
                />
                <SimpleDDL
                  label="Wilayah"
                  id="select_options_wilayah"
                  box="search"
                  name="wilayah"
                  options={areaOption}
                  isClearable
                  value={filter.wilayah}
                  onChange={(value) =>
                    this.handleSetValue({ value, name: "wilayah" })
                  }
                />
                <SimpleDDL
                  label="Cabang Berlaku"
                  id="select_cabang"
                  box="multiselect"
                  name="kodeCabang"
                  options={cabangOptions}
                  isClearable
                  value={filter?.kodeCabang}
                  onChange={(value) =>
                    this.handleSetValue({ value, name: "kodeCabang" })
                  }
                />
                <SimpleDDL
                  label="Status"
                  id="select_status"
                  name="status"
                  box="search"
                  isClearable
                  options={this.state.statusData}
                  value={this.state.filter.status}
                  onChange={(value) =>
                    this.handleSetValue({ value, name: "status" })
                  }
                />
              </FlexView>
              <FlexView style={{ justifyContent: "flex-end" }}>
                <FlexView style={{ gap: "10px" }}>
                  <SimpleButton text="Hapus" onClick={this.handleClear} />
                  <SimpleButton text="Terapkan" onClick={this.handleSubmit} />
                </FlexView>
              </FlexView>
            </ModalContainer>
          }
        />
      </React.Fragment>
    );
  }
}

export default MasterPromoFilter;
